var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("div", { staticClass: "col-xs-12" }, [
        _c(
          "div",
          { staticClass: "large" },
          [
            _c("FullCalendar", {
              ref: "calendar",
              attrs: {
                events: _vm.calendar,
                defaultView: "dayGridMonth",
                weekends: true,
                selectable: true,
                plugins: _vm.calendarPlugins,
                header: _vm.headerToolbar,
                views: _vm.views,
                buttonText: _vm.todayButtonText,
                datesRender: _vm.loadCalendar,
                eventRender: _vm.updateEvents,
                locale:
                  _vm.getSelectedLocale.LOCALE_CODE !== "sa-us"
                    ? _vm.getSelectedLocale.LOCALE_CODE
                    : "en-us"
              },
              on: { eventClick: _vm.eventClicked }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "small" },
          [
            _c("FullCalendar", {
              ref: "calendar",
              attrs: {
                events: _vm.calendar,
                defaultView: "dayGridMonth",
                weekends: true,
                selectable: true,
                plugins: _vm.calendarPlugins,
                header: _vm.smallHeaderToolbar,
                footer: _vm.smallFooterToolbar,
                views: _vm.views,
                buttonText: _vm.todayButtonText,
                datesRender: _vm.loadCalendar,
                eventRender: _vm.updateEvents,
                locale:
                  _vm.getSelectedLocale.LOCALE_CODE !== "sa-us"
                    ? _vm.getSelectedLocale.LOCALE_CODE
                    : "en-us"
              },
              on: { eventClick: _vm.eventClicked }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            "modal-title": _vm.modalData.COURSE,
            show: _vm.showModal,
            "dialog-size": "lg",
            name: "incidentDescription",
            fields: ""
          },
          on: {
            close: function($event) {
              return _vm.closeModal()
            }
          }
        },
        [
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.modalData.DESCRIPTION) }
          }),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("span", [
            _c("strong", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "MAIN_CONTENT.StudentCalendar.startDateTitleCaseWithColon"
                  )
                ) + " "
              )
            ]),
            _vm._v(" " + _vm._s(_vm.modalData.START_DATE) + "\n\t\t")
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("span", [
            _c("strong", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "MAIN_CONTENT.StudentCalendar.dueDateTitleCaseWithColon"
                  )
                ) + " "
              )
            ]),
            _vm._v(" " + _vm._s(_vm.modalData.END_DATE) + "\n\t\t")
          ]),
          _vm._v(" "),
          _c("template", { attrs: { close: _vm.closeModal }, slot: "footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-default",
                attrs: { type: "button" },
                on: { click: _vm.closeModal }
              },
              [
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(_vm.$t("MAIN_CONTENT.commonContent.closeButton")) +
                    "\n\t\t\t"
                )
              ]
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }